import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { DataService } from 'src/app/services/data.service';

@Component({
  templateUrl: './days.component.html',
  styleUrls: ['./days.component.scss'],
})
export class DaysComponent {

  days = [1, 2]
  week_id: number = null
  dayOneFinished: boolean = false
  twentyFourHoursOrMore: boolean = false

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private dataService: DataService,
    private navCtrl: NavController,
  ) {
    this.week_id = Number(this.route.snapshot.params.week_id)
    this.checkDayOneFinished()
  }

  navigateBackToWeeks() {
    this.navCtrl.navigateBack(`weeks`)
  }

  async checkDayOneFinished() {
    this.dayOneFinished = await this.dataService.dayCompleted(this.week_id, 1)
    this.twentyFourHoursOrMore = await this.dataService.check24HoursOrMore()
  }

  canOpenDayTwo(day: number) {
    // return (
    //   (day == 2 && !this.dayOneFinished) ||
    //   (day == 2 && !this.twentyFourHoursOrMore)
    // ) ? true : false;
    return (day == 2 && !this.dayOneFinished) ? true : false;
  }

  onItemClick(day: number) {
    this.router.navigateByUrl(`workouts/${this.week_id}`, {
      state: {
        day
      }
    })
  }

}
